<template>
  <div class="c-library-book-download">
    <button
      class="c-library-book-download__button"
      :tabindex="tabAble ? 0 : -1"
      @click="actionClick"
      :aria-label="status === 'ONLINE' ? $t('DOWNLOAD') : false"
    >
      <div v-if="status === 'ONLINE'" class="c-library-book-download__wrapper">
        <span class="c-library-book-download__text">
          {{ $t('DOWNLOAD') }}
        </span>
      </div>
      <library-book-circle-progress
        v-if="showLoadingCircle"
        class="c-library-book-circle-progress"
        :radius="15"
        :stroke="2"
        :progress="progress"
        strokeColor="#363a5e"
      ></library-book-circle-progress>
      <icon-download
        v-if="showDownloadIcon"
        class="c-library-book-download__icon"
        :class="{'c-library-book-download__icon--downloading': animateIcon}"
      ></icon-download>
      <icon-archive
        v-if="showArchiveIcon"
        class="c-library-book-download__icon"
        :class="{'c-library-book-download__icon--archiving': animateIcon}"
      ></icon-archive>
      <div class="c-library-book-download__loading"></div>
      <div v-if="status === 'OFFLINE_READY'" class="c-library-book-download__icon c-library-book-download__icon--icon-check"></div>
    </button>
  </div>
</template>

<script>
import IconArchive from '@/assets/svg/Archive'
import IconDownload from '@/assets/svg/DownloadLibraryBook'
import LibraryBookCircleProgress from '@/components/LibraryBookCircleProgress'

export default {
  name: 'LibraryBookDownload',

  components: {
    'icon-archive': IconArchive,
    'icon-download': IconDownload,
    'library-book-circle-progress': LibraryBookCircleProgress
  },

  computed: {
    tabAble() {
      // Allow user to tab through only if can do any action
      return this.status === 'ONLINE'
    },

    showDownloadIcon() {
      return this.status === 'ONLINE' || this.status === 'DOWNLOADING' || this.status === 'PROCESSING'
    },

    showArchiveIcon() {
      return this.status === 'ARCHIVING'
    },

    showLoadingCircle() {
      return this.status === 'DOWNLOADING'
    },

    animateIcon() {
      return this.status === 'DOWNLOADING' || this.status === 'PROCESSING' || this.status === 'ARCHIVING'
    }
  },

  props: {
    status: String,
    progress: Number
  },

  methods: {
    actionClick() {
      if (this.status === 'ONLINE') {
        this.$emit('action-click')
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/_vars.scss';
@import '@/assets/scss/_mixin.scss';

.c-library-book-download {
  position: absolute;
  left: calc(50% + 45px);
  top: 165px;
  z-index: 3;
}

.c-library-book-circle-progress {
  position: absolute;
}

.c-library-book-download__button {
  @include btnReset();
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  width: 30px;
  height: 30px;

  background: $white;
  border: solid 2px $dark-blue;
  border-radius: 50%;

  font-size: 0.8rem;
  font-weight: 700;
  color: $dark-blue;

  cursor: pointer;

  @include a11yOutline();
}

.c-library-book-download__wrapper {
  display: flex;
  align-items: center;
  position: absolute;

  height: 26px;
  white-space: nowrap;
  padding: 0 1rem 0 1rem;
  right: 0.8rem;

  border: 2px solid $dark-blue;
  border-right: none;
  border-top-left-radius: 2rem;
  border-bottom-left-radius: 2rem;
  background: $white;
  opacity: 0;

  .c-library-book-download__button:hover & {
    opacity: 1;
  }
}

.c-library-book-download__icon {
  z-index: 9;

  &--icon-check {
    content: '';
    top: 5px;
    width: 7px;
    height: 12px;
    border: solid $dark-blue;
    border-width: 0 3px 3px 0;
    transform: rotate(45deg);
  }

  &--downloading {
    overflow: visible;

    .dlb__arrow {
      animation-name: bounce;
      animation-duration: 0.6s;
      animation-fill-mode: both;
      animation-timing-function: linear;
      animation-iteration-count: infinite;
    }
  }

  &--archiving {
    overflow: visible;
    animation-name: bounce;
    animation-duration: 0.7s;
    animation-fill-mode: both;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
  }
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-2px);
  }
}
</style>
